import React from 'react'
import './SeeQuoteModal.css'
import { Modal, Box } from '@mui/material'
import { CloseModalIconButton } from 'src/components/CloseModalIconButton'
import { useTranslation } from 'react-i18next'
import { acceptJobQuote, MultilangJob, declineQuote, downloadQuotePdf } from 'src/services/api/document'

interface Props {
    open: boolean
    handleClose: () => void
    job: MultilangJob
  }

function SeeQuoteModal({ open, handleClose, job } : Props) {
  const { t } = useTranslation('common')
  const accept = async () => {
    await acceptJobQuote(job.id) 
    handleClose()
  }
  const reject = async () => {
    await declineQuote(job.id) 
    handleClose()
  }
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      BackdropProps={{ className: 'see-quote-modal' }}
    >
      <Box className="see-quote-box">
        <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 1 }}>
          <CloseModalIconButton onClose={handleClose} />
        </Box>
        <div className="upper-area">
          <div className="title">{t('quote.quoteFor')}</div>
          <div className="project-name">{job.projectName}</div>
        </div>
        <div className="price">{job.currency} {job.quotedTotalCost?.toFixed(2)}</div>
        <div className="buttons">
          <button className="button-go" onClick={accept} disabled={job.status == 'QUOTING'}>{t('quote.goAhead')}</button>
          <button className="button-decline" onClick={reject} disabled={job.status == 'QUOTING'}>{t('quote.decline')}</button>
          {job.status === 'QUOTED' && (
            <button className="button-download-pdf" onClick={() => downloadQuotePdf(job)}>{t('quote.downloadPdf')}</button>
          )}
        </div>
      </Box>
    </Modal>
  )
}

export default SeeQuoteModal
